export default __webpack_public_path__ + "static/media/tour-3.5e078721.svg";